<template>
  <div class="">
    <el-table :data="logsList" style="width: 100%" border height="500" v-loading="loading">
      <el-table-column prop="status" label="操作内容" width="160"></el-table-column>
      <el-table-column prop="admin" label="操作者" width="160"></el-table-column>
      <el-table-column prop="ip" label="IP" width="160"></el-table-column>
      <el-table-column prop="created_at" label="时间" width="160">
        <template slot-scope="scope">
          <span>{{scope.row.created_at | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="total_count > params.pageSize" class="content-left content-top-padded">
      <el-pagination
      layout="prev, pager, next"
      @current-change="handleCurrentChange"
      :current-page.sync="params.page"
      :total="total_count" :page-size="params.pageSize">
      </el-pagination>
    </div>
  </div>
</template>
<script>
  import { Message } from 'element-ui'
  import {getCzLogs} from "../../api/qualification";


  export default {
    data () {
      return {
        logsList: [],
        companyList: [],
        companyTotal: 0,
        companyPageSize: 10,
        companyName: '',
        loading: false,
        total_count: 0,
        params: {
          page: 1,
          pageSize: 20
        },
        renderable: true
      }
    },
    methods: {
      handleCurrentChange (page_num) {
        this.params.page = page_num
        this.getDataList()
      },
      getDataList () {
        this.loading = true
        getCzLogs(this.params).then(response => {
          console.log(response)
          this.logsList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
        })
      }
    },
    mounted () {
      this.getDataList();
    }
  }
</script>
<style>
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 90%;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
    img {
      width: 90%;
    }
  }
  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }
  .service-label .el-checkbox:first-child{
    margin-left: 15px;
  }
  .service-label .el-input:first-child{
    margin-left: 15px;
  }
  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }
  .el-carousel {
    width: 375px;
  }
</style>
<style>
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100%!important;
    }
    img {
      width: 100%;
    }
  }
  .grid-attribute {
    table {
      width: 100%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// sysnc.vue?712b013c